import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import * as utils from "@/js/utils.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
  ValidationProvider,
  ValidationObserver,
  configure,
  extend
} from "vee-validate";
import { required, max, min, integer, size } from "vee-validate/dist/rules";

import i18n from "./lang/i18n";
import vuetify from "./plugins/vuetify";

import authentication from "@/plugins/keycloak";

library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// Start: Vee-Validate
Vue.component("validation-provider", ValidationProvider);
Vue.component("validation-observer", ValidationObserver);

//Rule hour before other field
extend("hourBefore", {
  params: ["target"],
  validate(value, { target }) {
    let minutesFrom = utils.hourToMinutes(target);
    let minutesTo = utils.hourToMinutes(value);
    return Number(minutesFrom) <= Number(minutesTo);
  },
  message: i18n.t(`global.validations.hourBefore`)
});

//Rule decimals
extend("decimal", {
  params: ["integer", "decimals"],
  validate: (
    value,
    { integer = "*", decimals = "*", separator = "." } = {}
  ) => {
    if (value === null || value === undefined || value === "") {
      return {
        valid: false
      };
    }
    const regexPartInteger = integer === "*" ? "+" : `{1,${integer}}`;
    const regexPartDecimal = decimals === "*" ? "+" : `{1,${decimals}}`;
    let regex = new RegExp(
      `^\\d${regexPartInteger}(\\${separator}\\d${regexPartDecimal})?$`
    );
    return regex.test(value);
  },
  message: i18n.t(`global.validations.decimal`)
});

configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid",
    dirty: ["is-dirty", "is-dirty"]
  },
  defaultMessage: (_, values) =>
    i18n.t(`global.validations.${values._rule_}`, values)
});

extend("required", required);
extend("max", max);
extend("min", min);
extend("integer", integer);
extend("size", size);
// End: Vee-Validate

Vue.prototype.$showError = function() {
  this.$root.$message(
    this.$t("global.error"),
    this.$t("global.error.genericMessage"),
    { color: "blue" }
  );
};

Vue.prototype.$showErrorMessage = function(message) {
  this.$root.$message(this.$t("global.error"), message, { color: "blue" });
};

Vue.prototype.$showErrorCode = function(code) {
  let messageProp = `global.error.api.${code}`;
  let message = i18n.t(messageProp);
  if (messageProp === message) {
    message = this.$t("global.error.genericMessage");
  }
  this.$root.$message(this.$t("global.error"), message, { color: "blue" });
};

Vue.config.productionTip = false;

Vue.prototype.$drawerMenu = false;

Vue.use(authentication);
Vue.$keycloak
  .init({ onLoad: "login-required", checkLoginIframe: false })
  .then(auth => {
    if (!auth) {
      window.location.reload();
    } else {
      new Vue({
        router,
        i18n,
        vuetify,
        render: h => h(App)
      }).$mount("#app");
    }
    //Token Refresh
    Vue.$keycloak.onTokenExpired = () => {
      console.log("expired " + new Date());
      Vue.$keycloak
        .updateToken(50)
        .success(refreshed => {
          if (refreshed) {
            console.log("refreshed " + new Date());
          } else {
            console.log("not refreshed " + new Date());
          }
        })
        .error(() => {
          console.error("Failed to refresh token " + new Date());
        });
    };
  })
  .catch(() => {
    console.error("Authenticated Failed");
  });
